/* eslint-disable max-statements */

import { Injectable } from '@angular/core';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';

import actionSaveIcon from '../svg/action-save.svg';
import addIcon from '../svg/add-24px.svg';
import alertIcon from '../svg/alert.svg';
import amCircleIcon from '../svg/am_circle.svg';
import amWithTextIcon from '../svg/am_with_text.svg';
import recordSoundIcon from '../svg/attachment_popup_record_sound.svg';
import recordVideoIcon from '../svg/attachment_popup_record_video.svg';
import takePictureIcon from '../svg/attachment_popup_take_picture.svg';
import attachmentWebformIcon from '../svg/attachment-webform.svg';
import audioIcon from '../svg/audio.svg';
import fileCopyIcon from '../svg/baseline-file.svg';
import unactiveCommentIcon from '../svg/button-unactive_comments.svg';
import activeCommentIcon from '../svg/button_active_comments.svg';
import calendarIcon from '../svg/calendar.svg';
import closedIcon from '../svg/closed.svg';
import closeIcon from '../svg/close_black_24dp.svg';
import commentIcon from '../svg/comment.svg';
import atConsignment from '../svg/consignment.svg';
import contactIcon from '../svg/contact.svg';
import copoDropdownIcon from '../svg/copo-dropdown.svg';
import copoPencilIcon from '../svg/copo-pencil.svg';
import declareQualityIcon from '../svg/declare_quality.svg';
import deleteIcon from '../svg/delete.svg';
import delteBinIcon from '../svg/delete_bin.svg';
import deliveredIcon from '../svg/delivered.svg';
import certificateIcon from '../svg/document/certificate.svg';
import dispatchAdviceIcon from '../svg/document/dispatch-advice.svg';
import documentFilePdfIcon from '../svg/document/file-pdf.svg';
import certificateListIcon from '../svg/document/icon-certificate.svg';
import dispatchAdviceListIcon from '../svg/document/icon-dispatch-advice.svg';
import invoiceListIcon from '../svg/document/icon-invoice.svg';
import orderAcknowledgementListIcon from '../svg/document/icon-order-acknowledgement.svg';
import invoiceIcon from '../svg/document/invoice.svg';
import orderAcknowledgmentIcon from '../svg/document/order-acknowledgment.svg';
import runningErrorIcon from '../svg/document/running_with_errors.svg';
import trainIcon from '../svg/document/train.svg';
import documentBoxIcon from '../svg/document_box.svg';
import draftIcon from '../svg/draft.svg';
import favoriteSelectedIcon from '../svg/favorites_selected.svg';
import favoriteUnselectedIcon from '../svg/favorites_unselected.svg';
import favoriteHeartSelectedIcon from '../svg/favorite_heart_selected.svg';
import favoriteHeartUnselectedIcon from '../svg/favorite_heart_unselected.svg';
import fileIcon from '../svg/file.svg';
import filtersIcon from '../svg/filters.svg';
import checkboxCheckedIcon from '../svg/form-checkbox-selected.svg';
import checkboxIcon from '../svg/form-checkbox-unselected.svg';
import garbageBlueIcon from '../svg/garbage-blue.svg';
import garbageIcon from '../svg/garbage.svg';
import headerProfileBigIcon from '../svg/header-profile-big.svg';
import headerProfileIcon from '../svg/header-profile.svg';
import homeIcon from '../svg/home.svg';
import iconAddtoCart from '../svg/icon-add_to_cart.svg';
import iconAddToCartBlue from '../svg/icon-add_to_cart_blue.svg';
import iconAddToCartGrey from '../svg/icon-add_to_cart_grey.svg';
import batchIcon from '../svg/icon-batch.svg';
import buildingIcon from '../svg/icon-building.svg';
import consignmentStockIcon from '../svg/icon-consignment.svg';
import feasiNotOk from '../svg/icon-feasi-nok.svg';
import feasiOk from '../svg/icon-feasi-ok.svg';
import feasiPending from '../svg/icon-feasi-pending.svg';
import dataCenterIcon from '../svg/icon-files_datacenter.svg';
import gorIcon from '../svg/icon-gor.svg';
import helpGreyIcon from '../svg/icon-help-grey.svg';
import helpWhiteIcon from '../svg/icon-help-white.svg';
import measurementIcon from '../svg/icon-measurement.svg';
import iconMill from '../svg/icon-mill.svg';
import exportZipIcon from '../svg/Icon-pdf_dl.svg';
import perforedSheetIcon from '../svg/icon-perfored_sheet.svg';
import redRealizedCumulIcon from '../svg/icon-realise-cumul-red.svg';
import greenRealizedCumulIcon from '../svg/icon-realised-cumul-green.svg';
import realizedCumulIcon from '../svg/icon-realised-cumul.svg';
import solarIcon from '../svg/icon-solar.svg';
import stockBlockedIcon from '../svg/icon-stock-blocked.svg';
import iconViewGrey from '../svg/icon-view-grey.svg';
import iconView from '../svg/icon-view.svg';
import weightIcon from '../svg/icon-weight.svg';
import wikiHelpIcon from '../svg/icon-wiki_help.svg';
import orderrequestIcon from '../svg/icon_orderrequest.svg';
import organicCoatingIcon from '../svg/icon_organic_coating.svg';
import restoreIcon from '../svg/icon_restore.svg';
import imageIcon from '../svg/image.svg';
import inProductionIcon from '../svg/in_production.svg';
import inStockIcon from '../svg/in_stock.svg';
import inStockOrange from '../svg/in_stock_alert_O.svg';
import inStockRed from '../svg/in_stock_alert_R.svg';
import inStockByVolumeIcon from '../svg/in_stock_by_volume.svg';
import inTransitIcon from '../svg/in_transit.svg';
import mailBoxIcon from '../svg/mail_box.svg';
import printIcon from '../svg/md/3rd_level_action-print.svg';
import mdAddIcon from '../svg/md/baseline-add_circle-24px.svg';
import mdArrowRight from '../svg/md/baseline-arrow_right_alt-24px.svg';
import mdCheckIcon from '../svg/md/baseline-check-24px.svg';
import mdDateRangeIcon from '../svg/md/baseline-date_range-24px.svg';
import mdDeleteIcon from '../svg/md/baseline-delete_outline-24px.svg';
import mdBaselineLensIcon from '../svg/md/baseline-lens-24px.svg';
import mdTableIcon from '../svg/md/baseline-table_chart-24px.svg';
import mdChatBubbleIcon from '../svg/md/chat_bubble_outline-24px.svg';
import mdDoneIcon from '../svg/md/done_outline-24px.svg';
import mdFilterIcon from '../svg/md/filter_list-24px.svg';
import mdForumIcon from '../svg/md/forum-24px.svg';
import mailIcon from '../svg/md/mail_outline-24px.svg';
import mdMoodIcon from '../svg/md/mood-24px.svg';
import mdBadMoodIcon from '../svg/md/mood_bad-24px.svg';
import mdAddToShoppingCart from '../svg/md/outline-add_shopping_cart-24px.svg';
import mdArrowDownwardIcon from '../svg/md/outline-arrow_downward-24px.svg';
import mdArrowForwardIcon from '../svg/md/outline-arrow_forward-24px.svg';
import mdAssignmentTurnedIn from '../svg/md/outline-assignment_turned_in-24px.svg';
import mdChevronLeftIcon from '../svg/md/outline-chevron_left-24px.svg';
import mdChevronRightIcon from '../svg/md/outline-chevron_right-24px.svg';
import mdCloseIcon from '../svg/md/outline-close-24px.svg';
import mdDownloadIcon from '../svg/md/outline-download-24px.svg';
import mdDragHandleIcon from '../svg/md/outline-drag_handle-24px.svg';
import mdDragIndicatorIcon from '../svg/md/outline-drag_indicator-24px.svg';
import mdDropDownIcon from '../svg/md/outline-drop_down-24px.svg';
import mdEditIcon from '../svg/md/outline-edit-24px.svg';
import mdFilterArrowDownIcon from '../svg/md/outline-filter_arrow_down-24px.svg';
import mdFilterArrowUpIcon from '../svg/md/outline-filter_arrow_up-24px.svg';
import mdFilterMenuIcon from '../svg/md/outline-filter_menu-24px.svg';
import mdFilterSelectedIcon from '../svg/md/outline-filter_selected-24px.svg';
import mdFirstPageIcon from '../svg/md/outline-first_page-24px.svg';
import mdHistory from '../svg/md/outline-history-24px.svg';
import mdKeyboardArrowDownIcon from '../svg/md/outline-keyboard_arrow_down-24px.svg';
import mdKeyboardArrowUpIcon from '../svg/md/outline-keyboard_arrow_up-24px.svg';
import mdLastPageIcon from '../svg/md/outline-last_page-24px.svg';
import mdLensIcon from '../svg/md/outline-lens-24px.svg';
import mdMenu from '../svg/md/outline-menu-24px.svg';
import mdMoreVertIcon from '../svg/md/outline-more_vert-24px.svg';
import mdAlert from '../svg/md/outline-notifications-24px.svg';
import mdRemoveIcon from '../svg/md/outline-remove-24px.svg';
import mdReorderIcon from '../svg/md/outline-reorder-24px.svg';
import mdSearchIcon from '../svg/md/outline-search-24px.svg';
import mdEyeIcon from '../svg/md/outline-visibility-24px.svg';
import pinIcon from '../svg/md/pin-24px.svg';
import pinIconFilled from '../svg/md/pin-24px-filled.svg';
import mdRestoreIcon from '../svg/md/restore_outline-24px.svg';
import mdStarIcon from '../svg/md/star-24px.svg';
import mdStarBorderIcon from '../svg/md/star_border-24px.svg';
import millStock from '../svg/mill_stock.svg';
import notificationIcon from '../svg/notification.svg';
import onVessel from '../svg/on_vessel.svg';
import orderedIcon from '../svg/ordered.svg';
import closedEye from '../svg/closed_eye.svg';
import openEye from '../svg/open_eye.svg';
import overseasStock from '../svg/overseas_stock.svg';
import pendingIcon from '../svg/pending.svg';
import plusIcon from '../svg/plus.svg';
import plusButton from '../svg/plus_button.svg';
import plusFilterIcon from '../svg/plus_icon.svg';
import refreshIcon from '../svg/refresh-24px.svg';
import removeIcon from '../svg/remove.svg';
import atReshipper from '../svg/reshipper.svg';
import saveDiskIcon from '../svg/save-disk.svg';
import saveIcon from '../svg/save.svg';
import searchIcon from '../svg/search.svg';
import schedule from '../svg/schedule.svg';
import sendIcon from '../svg/send.svg';
import settingsIcon from '../svg/settings.svg';
import shareIcon from '../svg/share.svg';
import sortingDownIcon from '../svg/sorting_down.svg';
import sortingIcon from '../svg/sorting_icon.svg';
import sortingUpIcon from '../svg/sorting_up.svg';
import statusDelivered from '../svg/status_delivered.svg';
import statusFull from '../svg/status_full.svg';
import statusRts from '../svg/status_rts.svg';
import statusRtsDelivered from '../svg/status_rts_delivered.svg';
import statusWip from '../svg/status_wip.svg';
import statusWipDelivered from '../svg/status_wip_delivered.svg';
import statusWipRts from '../svg/status_wip_rts.svg';
import checkboxIndeterminateIcon from '../svg/table-deselect-items.svg';
import tableDocumentIcon from '../svg/table-document.svg';
import userIcon from '../svg/user.svg';
import videoIcon from '../svg/video.svg';
import timesEndsIcon from '../svg/times_ends.svg';
import auctionGavelIcon from '../svg/auction_gavel_icon.svg';
import locationIcon from '../svg/md/geo-alt.svg';
import airPlaneIcon from '../svg/md/airplane.svg';
import iconModelled from '../svg/icon-modelled_data.svg';
import iconDataTransmitted from '../svg/icon-data_transmitted.svg';
import iconMeasured from '../svg/icon-measured_datas.svg';
import uploadIcon from '../svg/upload.svg';
import fullyConfigured from '../svg/fully_configured.svg';
import fromMannequinIcon from '../svg/icon_from_mannequin.svg';
import eyeIcon from '../svg/icon_eye.svg';
import nonFullyConfigured from '../svg/non_fully_configured.svg';
import statusIcon from '../svg/icon-black-circle.svg';
import mdEyeOpenIcon from '../svg/md/eye.svg';
import mdEyeCloseIcon from '../svg/md/eye_hidden.svg';

@Injectable({ providedIn: 'root' })
export class IconService {
	constructor(
		private readonly sanitizer: DomSanitizer,
		private readonly iconRegistry: MatIconRegistry,
	) {
		// nothing
	}

	registerAllIcons() {
		this.registerIcon('search', searchIcon);
		this.registerIcon('home', homeIcon);
		this.registerIcon('alert', alertIcon);
		this.registerIcon('am_with_text', amWithTextIcon);
		this.registerIcon('image', imageIcon);
		this.registerIcon('video', videoIcon);
		this.registerIcon('audio', audioIcon);
		this.registerIcon('file', fileIcon);
		this.registerIcon('attachment_popup_take_picture', takePictureIcon);
		this.registerIcon('attachment_popup_record_video', recordVideoIcon);
		this.registerIcon('attachment_popup_record_sound', recordSoundIcon);
		this.registerIcon('header_profile', headerProfileIcon);
		this.registerIcon('header_profile_big', headerProfileBigIcon);
		this.registerIcon('declare_quality', declareQualityIcon);
		this.registerIcon('draft', draftIcon);
		this.registerIcon('pending', pendingIcon);
		this.registerIcon('closed', closedIcon);
		this.registerIcon('settings', settingsIcon);
		this.registerIcon('filters', filtersIcon);
		this.registerIcon('save', saveIcon);
		this.registerIcon('am_circle', amCircleIcon);
		this.registerIcon('notification', notificationIcon);
		this.registerIcon('send', sendIcon);
		this.registerIcon('delivered', deliveredIcon);
		this.registerIcon('in_production', inProductionIcon);
		this.registerIcon('in_stock', inStockIcon);
		this.registerIcon('in_stock_red', inStockRed);
		this.registerIcon('in_stock_orange', inStockOrange);
		this.registerIcon('in_stock_by_volume', inStockByVolumeIcon);
		this.registerIcon('in_transit', inTransitIcon);
		this.registerIcon('ordered', orderedIcon);
		this.registerIcon('closed_eye', closedEye);
		this.registerIcon('schedule', schedule);
		this.registerIcon('open_eye', openEye);
		this.registerIcon('icon_orderrequest', orderrequestIcon);
		this.registerIcon('certificate', certificateIcon);
		this.registerIcon('icon_certificate', certificateListIcon);
		this.registerIcon('icon_invoice', invoiceListIcon);
		this.registerIcon('icon_dispatch_advice', dispatchAdviceListIcon);
		this.registerIcon('icon_cumul_red', redRealizedCumulIcon);
		this.registerIcon('icon_cumul_green', greenRealizedCumulIcon);
		this.registerIcon(
			'icon_order_acknowledgement',
			orderAcknowledgementListIcon
		);
		this.registerIcon('add_to_cart', iconAddtoCart);
		this.registerIcon('feasi_notok', feasiNotOk);
		this.registerIcon('feasi_ok', feasiOk);
		this.registerIcon('feasi_pending', feasiPending);
		this.registerIcon('add_to_cart_blue', iconAddToCartBlue);
		this.registerIcon('add_to_cart_grey', iconAddToCartGrey);
		this.registerIcon('icon_mill', iconMill);
		this.registerIcon('icon_view', iconView);
		this.registerIcon('icon_view_grey', iconViewGrey);
		this.registerIcon('train', trainIcon);
		this.registerIcon('dispatch_advice', dispatchAdviceIcon);
		this.registerIcon('invoice', invoiceIcon);
		this.registerIcon('order_acknowledgment', orderAcknowledgmentIcon);
		this.registerIcon('pdf', documentFilePdfIcon);
		this.registerIcon('favorites_selected', favoriteSelectedIcon);
		this.registerIcon('favorites_unselected', favoriteUnselectedIcon);
		this.registerIcon('favorite_heart_selected', favoriteHeartSelectedIcon);
		this.registerIcon('favorite_heart_unselected', favoriteHeartUnselectedIcon);
		this.registerIcon('table_document', tableDocumentIcon);
		this.registerIcon('attachment_webform', attachmentWebformIcon);
		this.registerIcon('checkbox', checkboxIcon);
		this.registerIcon('plus', plusIcon);
		this.registerIcon('garbage', garbageIcon);
		this.registerIcon('garbage_blue', garbageBlueIcon);
		this.registerIcon('measurement_icon', measurementIcon);
		this.registerIcon('weight_icon', weightIcon);
		this.registerIcon('help_icon_white', helpWhiteIcon);
		this.registerIcon('help_icon_grey', helpGreyIcon);
		this.registerIcon('copo_pencil', copoPencilIcon);
		this.registerIcon(
			'checkbox_checked',
			checkboxCheckedIcon
		);
		this.registerIcon('checkbox_indeterminate', checkboxIndeterminateIcon);
		this.registerIcon('status_delivered', statusDelivered);
		this.registerIcon('status_full', statusFull);
		this.registerIcon('status_rts', statusRts);
		this.registerIcon('status_rts_delivered', statusRtsDelivered);
		this.registerIcon('status_wip', statusWip);
		this.registerIconInNamespace(
			'md',
			'running_with_error',
			runningErrorIcon
		);
		this.registerIcon('status_wip_delivered', statusWipDelivered);
		this.registerIcon('status_wip_rts', statusWipRts);
		this.registerIcon('plus_button', plusButton);
		this.registerIcon('user', userIcon);
		this.registerIcon('data_center', dataCenterIcon);
		this.registerIcon('at_consignment', atConsignment);
		this.registerIcon('mill_stock', millStock);
		this.registerIcon('on_vessel', onVessel);
		this.registerIcon('at_reshipper', atReshipper);
		this.registerIcon('mail', mailIcon);
		this.registerIcon('delete', deleteIcon);
		this.registerIcon('add', addIcon);
		this.registerIcon('delete_bin', delteBinIcon);
		this.registerIcon('calendar', calendarIcon);
		this.registerIcon('save_disk', saveDiskIcon);
		this.registerIcon('sorting_down', sortingDownIcon);
		this.registerIcon('sorting_up', sortingUpIcon);
		this.registerIcon('sorting_icon', sortingIcon);
		this.registerIcon('gor_icon', gorIcon);
		this.registerIcon('plus_icon', plusFilterIcon);
		this.registerIcon('remove', removeIcon);
		this.registerIcon('action_save', actionSaveIcon);
		this.registerIcon('copo_dropdown', copoDropdownIcon);
		this.registerIcon('share', shareIcon);
		this.registerIconInNamespace('md', 'star_border', mdStarBorderIcon);
		this.registerIconInNamespace('md', 'star', mdStarIcon);
		this.registerIcon('fileCopy', fileCopyIcon);
		this.registerIcon('refresh', refreshIcon);
		this.registerIcon('realized_cumul', realizedCumulIcon);
		this.registerIcon('consignment_stock', consignmentStockIcon);
		this.registerIcon('stock_blocked', stockBlockedIcon);
		this.registerIconInNamespace('md', 'search', mdSearchIcon);
		this.registerIconInNamespace('md', 'more_vert', mdMoreVertIcon);
		this.registerIconInNamespace('md', 'close', mdCloseIcon);
		this.registerIconInNamespace('md', 'zipPdf', exportZipIcon);
		this.registerIconInNamespace('md', 'arrow_forward', mdArrowForwardIcon);
		this.registerIconInNamespace(
			'md',
			'keyboard_arrow_down',
			mdKeyboardArrowDownIcon
		);
		this.registerIconInNamespace(
			'md',
			'keyboard_arrow_up',
			mdKeyboardArrowUpIcon
		);
		this.registerIconInNamespace('md', 'baseline_lens', mdBaselineLensIcon);
		this.registerIconInNamespace('md', 'lens', mdLensIcon);
		this.registerIconInNamespace('md', 'chevron_right', mdChevronRightIcon);
		this.registerIconInNamespace('md', 'chevron_left', mdChevronLeftIcon);
		this.registerIconInNamespace('md', 'menu', mdMenu);
		this.registerIconInNamespace('md', 'history', mdHistory);
		this.registerIconInNamespace('md', 'alert_notification', mdAlert);
		this.registerIconInNamespace('md', 'first_page', mdFirstPageIcon);
		this.registerIconInNamespace('md', 'last_page', mdLastPageIcon);
		this.registerIconInNamespace('md', 'add', mdAddIcon);
		this.registerIconInNamespace('md', 'download', mdDownloadIcon);
		this.registerIconInNamespace('md', 'reorder', mdReorderIcon);
		this.registerIconInNamespace('md', 'drag_handle', mdDragHandleIcon);
		this.registerIconInNamespace('md', 'filter', mdFilterIcon);
		this.registerIconInNamespace(
			'md',
			'drag_indicator',
			mdDragIndicatorIcon
		);
		this.registerIconInNamespace(
			'md',
			'arrow_downward',
			mdArrowDownwardIcon
		);
		this.registerIconInNamespace('md', 'remove', mdRemoveIcon);
		this.registerIconInNamespace('md', 'edit', mdEditIcon);
		this.registerIconInNamespace('md', 'arrow_right', mdArrowRight);
		this.registerIconInNamespace('md', 'check', mdCheckIcon);
		this.registerIconInNamespace('md', 'date_range', mdDateRangeIcon);
		this.registerIconInNamespace('md', 'delete', mdDeleteIcon);
		this.registerIconInNamespace('md', 'table', mdTableIcon);
		this.registerIconInNamespace('md', 'forum', mdForumIcon);
		this.registerIconInNamespace(
			'md',
			'assignment_turned_in',
			mdAssignmentTurnedIn
		);
		this.registerIconInNamespace('md', 'eye', mdEyeIcon);
		this.registerIconInNamespace(
			'md',
			'add_to_shopping_cart',
			mdAddToShoppingCart
		);
		this.registerIconInNamespace(
			'md',
			'pin',
			pinIcon
		);
		this.registerIconInNamespace(
			'md',
			'pinFilled',
			pinIconFilled
		);
		this.registerIconInNamespace(
			'md',
			'filter_arrow_down',
			mdFilterArrowDownIcon
		);
		this.registerIconInNamespace(
			'md',
			'filter_arrow_up',
			mdFilterArrowUpIcon
		);
		this.registerIconInNamespace('md', 'filter_menu', mdFilterMenuIcon);
		this.registerIconInNamespace(
			'md',
			'filter_selected',
			mdFilterSelectedIcon
		);
		this.registerIconInNamespace('md', 'drop_down', mdDropDownIcon);
		this.registerIconInNamespace('md', 'chat_bubble', mdChatBubbleIcon);
		this.registerIconInNamespace('md', 'done', mdDoneIcon);
		this.registerIconInNamespace('md', 'restore', mdRestoreIcon);
		this.registerIcon('mail_box', mailBoxIcon);
		this.registerIcon('document_box', documentBoxIcon);
		this.registerIcon('overseas_stock', overseasStock);
		this.registerIconInNamespace('md', 'mood', mdMoodIcon);
		this.registerIconInNamespace('md', 'bad_mood', mdBadMoodIcon);
		this.registerIcon('icon_restore', restoreIcon);
		this.registerIcon('contact', contactIcon);
		this.registerIcon('close', closeIcon);
		this.registerIcon('wiki_help', wikiHelpIcon);
		this.registerIcon('icon-batch', batchIcon);
		this.registerIcon('activeComment', activeCommentIcon);
		this.registerIcon('unactiveComment', unactiveCommentIcon);
		this.registerIcon('unactiveComment', unactiveCommentIcon);
		this.registerIcon('comment', commentIcon);
		this.registerIconInNamespace('md', 'print', printIcon);
		this.registerIcon('wiki_help', wikiHelpIcon);
		this.registerIcon('solar_icon', solarIcon);
		this.registerIcon('building_icon', buildingIcon);
		this.registerIcon('perfored_sheet_icon', perforedSheetIcon);
		this.registerIcon('icon_organic_coating', organicCoatingIcon);
		this.registerIcon('times_ends', timesEndsIcon);
		this.registerIcon('auction_gavel_icon', auctionGavelIcon);
		this.registerIcon('air_plane', airPlaneIcon);
		this.registerIcon('geo-alt', locationIcon);
		this.registerIcon('icon-modelled', iconModelled);
		this.registerIcon('icon-transmitted', iconDataTransmitted);
		this.registerIcon('icon-measured', iconMeasured);
		this.registerIcon('icon-upload', uploadIcon);
		this.registerIcon('fully-configured', fullyConfigured);
		this.registerIcon('icon_from_mannequin', fromMannequinIcon);
		this.registerIcon('icon-eye', eyeIcon);
		this.registerIcon('non-fully-configured', nonFullyConfigured);
		this.registerIcon('icon-status', statusIcon);
		this.registerIconInNamespace('md', 'eye_open', mdEyeOpenIcon);
		this.registerIconInNamespace('md', 'eye_close', mdEyeCloseIcon);
	}

	registerIcon(iconName: string, iconSvg: string) {
		// eslint-disable-next-line sonarjs/no-angular-bypass-sanitization
		this.iconRegistry.addSvgIconLiteral(iconName, this.sanitizer.bypassSecurityTrustHtml(iconSvg));
	}

	registerIconInNamespace(namespace: string, iconName: string, iconSvg: string) {
		this.iconRegistry.addSvgIconLiteralInNamespace(
			namespace,
			iconName,
			// eslint-disable-next-line sonarjs/no-angular-bypass-sanitization
			this.sanitizer.bypassSecurityTrustHtml(iconSvg)
		);
	}
}
